<div
  class="flex items-stretch @container"
  [ngClass]="
    {
      NONE: '',
      ALERT: 'bg-error-soft/50 dark:bg-error-soft-darkmode/50',
      INFO: 'bg-primary-soft/25 dark:bg-primary-soft-darkmode/25',
      NOT_SET: '',
    }[data().result]
  "
>
  <div class="flex-none flex py-5 px-4 border-r border-outline dark:border-outline-darkmode">
    <div class="w-6 flex items-center justify-center">
      @if (data().result !== 'NOT_SET') {
        <div
          class="border rounded-full size-6 flex items-center justify-center"
          [ngClass]="
            {
              NONE: 'border-secondary-soft-outline dark:border-secondary-soft-outline-darkmode text-on-secondary-soft dark:text-on-secondary-soft-darkmode bg-secondary-soft dark:bg-secondary-soft-darkmode',
              ALERT:
                'border-error-outline dark:border-error-outline-darkmode bg-error dark:bg-error-darkmode text-on-error dark:text-on-error-darkmode',
              INFO: 'border-primary-soft-outline dark:border-primary-soft-outline-darkmode text-on-primary-soft dark:text-on-primary-soft-darkmode bg-primary-soft dark:bg-primary-soft-darkmode',
              NOT_SET: '',
            }[data().result]
          "
        >
          @switch (data().result) {
            @case ('NONE') {
              <ng-icon name="heroMinus" size="16" class="!block" />
            }
            @case ('ALERT') {
              <ng-icon name="heroXMark" size="16" class="!block" />
            }
            @case ('INFO') {
              <ng-icon name="roundedSquare" size="9" class="!block" />
            }
          }
        </div>
      }
    </div>
  </div>
  <div class="flex-1 flex items-center px-6 py-4 gap-6">
    <div class="flex-1 flex flex-col justify-center">
      <span class="text-sm font-semibold leading-6">
        <ng-content select="[slot=title]" />
      </span>
      <span class="text-on-surface-variant dark:text-on-surface-variant-darkmode leading-4 text-xs">
        <ng-content select="[slot=subtitle]" />
      </span>
    </div>
    @if (!showReport() && (data().explanation || data().documentId)) {
      <ui-button
        mode="outlined"
        size="small"
        (click)="showReport.set(true)"
        class="min-w-35"
        expand="full"
        >{{ 'cockpit.supplierContracts.check.item.showReport' | transloco }}</ui-button
      >
    } @else if (showReport()) {
      <ui-button
        mode="outlined"
        size="small"
        (click)="showReport.set(false)"
        class="min-w-35"
        expand="full"
        >{{ 'cockpit.supplierContracts.check.item.hideReport' | transloco }}</ui-button
      >
    }
  </div>
</div>
<div
  class="overflow-hidden transition-[height] duration-300"
  uiDetectBrowser
  [ngClass]="showReport() ? 'open' : 'closed'"
>
  <div
    class="flex px-[81px] pt-8 pb-12 border-t border-outline dark:border-outline-darkmode overflow-hidden"
  >
    <div class="flex flex-col gap-4">
      <div class="flex flex-col gap-1">
        <div class="flex gap-2 items-center">
          <h5 class="text-sm font-semibold leading-6">
            {{ 'cockpit.supplierContracts.check.item.riskAssessment' | transloco }}
          </h5>
          <ui-help-button class="flex-none -m-[5px]">
            <h3 slot="title" class="font-semibold">
              {{ 'help.supplierContracts.check.riskAssessment.title' | transloco }}
            </h3>
            {{ 'help.supplierContracts.check.riskAssessment.content' | transloco }}
          </ui-help-button>
        </div>
        @switch (data().result) {
          @case ('ALERT') {
            <ui-badge color="error">
              {{ 'cockpit.supplierContracts.check.item.riskAlert' | transloco }}
            </ui-badge>
          }
          @case ('INFO') {
            <ui-badge color="primary">
              {{ 'cockpit.supplierContracts.check.item.riskInfo' | transloco }}
            </ui-badge>
          }
          @case ('NONE') {
            <ui-badge color="soft">
              {{ 'cockpit.supplierContracts.check.item.riskNone' | transloco }}
            </ui-badge>
          }
          @case ('NOT_SET') {
            <ui-badge color="soft">
              {{ 'cockpit.supplierContracts.check.item.riskNotSet' | transloco }}
            </ui-badge>
          }
        }
      </div>
      @if (data().explanation; as explanation) {
        <div class="flex flex-col gap-1">
          <div class="flex gap-2 items-center">
            <h5 class="text-sm font-semibold leading-6">
              {{ 'cockpit.supplierContracts.check.item.shortReport' | transloco }}
            </h5>
            <ui-help-button class="flex-none -m-[5px]">
              <h3 slot="title" class="font-semibold">
                {{ 'help.supplierContracts.check.shortReport.title' | transloco }}
              </h3>
              {{ 'help.supplierContracts.check.shortReport.content' | transloco }}
            </ui-help-button>
          </div>
          <pre
            class="text-sm leading-6 font-normal text-on-surface-subtle dark:text-on-surface-subtle-darkmode whitespace-pre-wrap font-sans"
            >{{ explanation }}</pre>
        </div>
      }
      @if (data().documentId; as documentId) {
        <div class="flex flex-col gap-1">
          <div class="flex gap-2 items-center">
            <h5 class="text-sm font-semibold leading-6">
              {{ 'cockpit.supplierContracts.check.item.analysisReport' | transloco }}
            </h5>
            <ui-help-button class="flex-none -m-[5px]">
              <h3 slot="title" class="font-semibold">
                {{ 'help.supplierContracts.check.analysisReport.title' | transloco }}
              </h3>
              {{ 'help.supplierContracts.check.analysisReport.content' | transloco }}
            </ui-help-button>
          </div>
          <div class="flex flex-col gap-5">
            <p
              class="text-sm leading-6 text-on-surface-subtle dark:text-on-surface-subtle-darkmode"
            >
              {{ 'cockpit.supplierContracts.check.item.downloadPdfMessage' | transloco }}
            </p>
            <ui-button mode="outlined" (click)="onClickDownload(documentId)">
              <ng-icon name="heroArrowDownTray" size="20" slot="start" class="!block" />
              {{ 'cockpit.supplierContracts.check.item.downloadButton' | transloco }}
            </ui-button>
          </div>
        </div>
      }
    </div>
  </div>
</div>
